import { render, staticRenderFns } from "./ImageCollectionElements.vue?vue&type=template&id=318d7406&"
import script from "./ImageCollectionElements.vue?vue&type=script&lang=js&"
export * from "./ImageCollectionElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports